import LoadHistory from "./LoadHistory";

export default LoadHistory;